import { createClassModuleFactory } from "../ui/factories/module-factory-helpers.js";

const error401PageFactory = createClassModuleFactory(() => import('./Error401Page.js'), 'Error401Page');
const error403PageFactory = createClassModuleFactory(() => import('./Error403Page.js'), 'Error403Page');
const error404PageFactory = createClassModuleFactory(() => import('./Error404Page.js'), 'Error404Page');

export const routes = [

    { name: 'error-unauthorized', path: '/error-unauthorized', factory: error401PageFactory, public: true },
    { name: 'error-forbidden', path: '/error-forbidden', factory: error403PageFactory, public: true },
    { name: 'error-not-found', path: '/error-not-found', factory: error404PageFactory, public: true },

];
